import { env } from "@/utils/env";
import type { SocketClient } from "socker/client";
import { useSocket } from "../useSocket";


export const useFindexSocket = (): SocketClient => {
  const url = env.VITE_APP_WEBSOCKET_URL;
  return useSocket({
    url: url
  });
}
